export class LogTransformer {
  static transform(obj) {
    let log = Object.assign({ id: parseInt(obj.id, 10) }, obj.attributes);
    return log;
  }
}
